import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ValuesType } from 'utility-types';
import { ActionShowModal, CheckerServiceModel, ModalModel, ServiceHandlerModel, ServiceID, ServiceModel } from '../../form-json.types';
import { ModalOptions } from '../../modal/modal.component';
import { DataService } from '../data/data.service';
import { FormCoreModule } from '../form-core.module';
import { ModalService } from '../modal/modal.service';
import { ServiceCheckerService } from '../service-checker/service-checker.service';

@Injectable({
  providedIn: FormCoreModule
})
export class ErrorHandlerService {

  constructor(private checker: ServiceCheckerService, private data: DataService, private modal: ModalService) { }

  initiate(errorHandler: ServiceHandlerModel) {
    return this.checker.check(this.data.getModel<CheckerServiceModel>(errorHandler.relationships.checker.data)).pipe(
      tap(res => {
        if (!res) {
          const actionShowModel = this.data.getModel<ActionShowModal>(errorHandler.relationships.action.data)
          const modalOptions = this.data.getModel<ModalModel>(actionShowModel.relationships.modal.data)
          const subTitle = modalOptions.attributes['sub-title']
          const { type, attributes: {title, content} } = modalOptions
          this.modal.create({type, title, content, "sub-title": subTitle})
        }
      })
    )
  }
}
